import { put } from '../../base';

export const updateLogo = (data: FormData): Promise<{ Name: string }> => put('v5/images', { body: data }).json();
